const styles = {
  searchHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 10,
    backgroundColor: 'white',
  },
  searchHeaderContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  searchHeaderInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  resultsForText: {
    fontSize: 12,
  },
  infoKeyText: {
    fontSize: 14,
    fontWeight: 400,
  },
  dataText: {
    fontSize: 14,
    fontWeight: 600,
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 4,
  },
};

export default styles;
